<template>
  <b-container fluid>
    <b-row>
      <b-col md="12">
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title">{{cvCardTitle}}</h4>
          </template>
          <template v-slot:headerAction>
            <b-button variant="primary" @click="gpcpAdd">{{cvbtnAddNew}}</b-button>
          </template>
          <template v-slot:body>
            <b-row class="row w-100">
              <!-- Frontend Search -->
              <!-- <b-col sm="4" md="4" lg="4" xl="4" class="mb-3">
                <b-form-input
                  id="search"
                  v-model="filter"
                  type="search"
                  :placeholder="cvSearchText"></b-form-input>
              </b-col>Frontend Search -->

              <!-- Backend Search -->
              <b-col class="col-12 col-sm-6 col-md-6 col-lg-4 mb-2">
                <b-form-input class="form-control"
                  @input="searchgpcpWithParams"
                  v-model="search_param"
                  type="search"
                  :placeholder="cvSearchText"></b-form-input>
              </b-col><!-- Backend Search -->
               <!-- GPath Producat Id -->
              <b-col class="col-12 col-sm-6 col-md-6 col-lg-3 mb-2">
                <select v-model="whereFilter.pdt_id" class="form-control" title="session states" @change="setPdtId">
                  <option v-for="item in gpcPdtIdList" :key="item.id" :value="item.id" >
                    {{ item.id }}
                  </option>
                </select>
              </b-col><!-- GPath Producat Id -->
              <b-col class="col-12 col-sm-12 col-md-12 col-lg-3 pr-0 mb-2">
                <div class="dateRange">
                  <date-range-picker ref="picker" class="w-100"  :locale-data="{ firstDay: 1, format: 'dd-mm-yyyy' }"  v-model="whereFilter.dateRange"  @update="getgpcpDateWise()" ></date-range-picker>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col class="container_minheight" md="12" v-if="gpcpObjList && gpcpObjList.length > 0">
                <b-table
                  hover
                  responsive
                  :items="gpcpObjList"
                  :fields="columns"
                  :no-border-collapse="true"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  :current-page="currentBatchNo"
                  :per-page="dataPerPage"
                >
                  <template v-slot:cell(name)="data">
                    {{ data.item.name }}<br>
                    <b-button variant="iq-bg-success mr-1 mb-1" size="sm" @click="gpcpEdit('MODAL', data.item)" v-if="!data.item.editable"><i class="ri-ball-pen-fill m-0 actionicon font-size-20"></i></b-button>
                    <b-button variant="iq-bg-danger" @click="showgpath_companyDeleteDialog(data.item)" size="sm"><i class="ri-delete-bin-line m-0 actionicon font-size-20"></i></b-button>
                  </template>
                  <template v-slot:cell(created_on)="data">
                    {{data.item.created_on | dateFormat}}
                  </template>
                </b-table>
              </b-col>
              <b-col class="container_minheight" md="12" v-else>
                No data found
              </b-col>
            </b-row>
            <b-col sm="12" md="12" class="my-1">
                <b-row>
                  <b-col sm="12" md="7">
                    <b-btn variant="primary" @click="loadMoreData" v-if="showLoadMoreBtn">Load More</b-btn>
                  </b-col>
                  <b-col sm="5" md="5">
                    <b-pagination
                      v-model="currentBatchNo"
                      :total-rows="totalRows"
                      :per-page="dataPerPage"
                      align="fill"
                      size="sm"
                      class="my-0"
                    ></b-pagination>
                  </b-col>
                </b-row>
              </b-col>
          </template>
        </iq-card>
      </b-col>
    </b-row>

    <b-modal
      v-model="showModelgpathCompanyAdd"
      scrollable
      :title="cvAddModalHeader"
    >
      <gpathCompanyAdd :propOpenedInModal="true" @emitClosegpathCompanyAddModal="closegpathCompanyAddModal" />
      <template #modal-footer="">
        <b-button size="sm" class="pull-left" @click="gpcpAdd('FULLPAGE')">
          {{cvbtnModalExpand}}
        </b-button>
        <b-button size="sm" @click="closegpathCompanyAddModal()">
          {{cvbtnModalCancel}}
        </b-button>
      </template>
    </b-modal>

    <b-modal
      v-model="showModelgpathCompanyEdit"
      scrollable
      :title="cvEditModalHeader"
    >
      <gpathCompanyEdit :propOpenedInModal="true" :propgpath_companyObj="gpcpEditObj" @emitClosegpathCompanyEditModal="closegpathCompanyEditModal" />
      <template #modal-footer="">
        <b-button size="sm" class="pull-left" @click="gpcpEdit('FULLPAGE')">
          {{cvbtnModalExpand}}
        </b-button>
        <b-button size="sm" @click="closegpathCompanyEditModal()">
          {{cvbtnModalCancel}}
        </b-button>
      </template>
    </b-modal>

    <b-modal v-model="showModelgpath_companyDelete" size="sm" title="Delete" ok-title="Delete" cancel-title="Cancel">
      <p>{{cvDelMessage}}</p>
      <template #modal-footer="">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" @click="showModelgpath_companyDelete = false">
          {{cvbtnModalCancel}}
        </b-button>
        <b-button size="sm" variant="primary" @click="gpcpDelete()">
          {{cvbtnModalDelOk}}
        </b-button>
      </template>
    </b-modal>

    <b-toast v-model="showToast" name="Toast" :variant="toastVariant" :title="toastTitle">
      <div v-html="toastMsg"></div>
    </b-toast>
  </b-container>
</template>
<script>
import { gpathCompanys } from "../../../FackApi/api/GpathCompany.js"
import gpathCompanyAdd from "./GpathCompanyAdd"
import gpathCompanyEdit from "./GpathCompanyEdit"
import moment from "moment"
import ApiResponse from "../../../Utils/apiResponse.js"
import { socialvue } from "../../../config/pluginInit.js"
import userPermission from "../../../Utils/user_permission.js"
import { GPathConfig } from "../../../FackApi/api/GpathConfig"

export default {
  name: "gpath_companyList",
  components: {
    gpathCompanyAdd,
    gpathCompanyEdit
  },
  data () {
    return {
      cvCardTitle: "GPath Company Recommendation",
      cvbtnAddNew: "Add",
      cvSearchText: "Type to Search",
      cvbtnModalDelOk: "Delete",
      cvDelMessage: "Are you sure?",
      cvEditModalHeader: "Edit GPath Company Recommendation",
      cvAddModalHeader: "Add GPath Company Recommendation",
      cvbtnModalCancel: "Cancel",
      cvbtnModalExpand: "Expand",
      showToast: false,
      toastMsg: null,
      toastVariant: "default",
      toastTitle: "GPath Company Recommendation",
      showModelgpathCompanyAdd: false,
      showModelgpathCompanyEdit: false,
      showModelgpath_companyDelete: false,
      sortBy: "name",
      sortDesc: false,
      columns: [
        { label: "# ", key: "id", class: "text-left align-text-top", sortable: true },
        { label: "Product Id", key: "pdt_id", class: "text-left align-text-top text-break w-100px", sortable: true },
        { label: "name", key: "name", class: "text-left align-text-top", sortable: true },
        { label: "career key", key: "career_key", class: "text-left align-text-top", sortable: true },
        { label: "company name", key: "company_name", class: "text-left align-text-top", sortable: true },
        { label: "company logo", key: "company_logo", class: "text-left align-text-top", sortable: true },
        { label: "Created On ", key: "created_on", class: "text-left align-text-top", sortable: true },
        { label: "Action ", key: "action", class: "text-left align-text-top", sortable: false }
      ],
      gpcpObjList: [],
      gpcpEditObj: null,
      filter: null,
      filterOn: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      delObj: null,
      whereFilter: {
        pdt_id: "",
        dateRange: {
          startDate: new Date(new Date().setDate(new Date().getDate() - 365)), // From Last Year
          endDate: new Date(new Date().setDate(new Date().getDate() + 1))
        }
      },
      search_param: "",
      currentBatchNo: 1,
      dataPerPage: 25,
      showLoadMoreBtn: true,
      gpcPdtIdList: []
    }
  },
  computed: {
    userData () {
      return this.$store.getters["User/userData"]
    },
    dateFilter () {
      return { ...this.$store.getters["DateFilter/selectedDateState"] }
    }
  },
  async beforeMount () {
    // Auth Access for Current User Role
    if (this.userData.user_role == "USERROLE11114") {
      // We will display only the sessions of the user, It is necessary when the user has multiple sessions and he/she wants to view the session
      // DONT CARE CASE
    }
    else if (!userPermission(this, this.userData, this.apiName)) {
      this.$router.back()
    }
  },
  async mounted () {
    await this.getDateFilter()
    socialvue.index()
    this.gpcpList()
    this.gpathsproductIdListGet()
  },
  methods: {
    /**
     * Calling SetPdtId into filter
    */
    async setPdtId () {
      this.gpcpList()
    },
    /**
     * Get daterange from LS. If found then use this as default else use the onse set in the data section of the object
    */
    async getDateFilter () {
      let storeDate = await this.dateFilter
      if (storeDate && storeDate.dateRange) {
        this.whereFilter = storeDate
      }
    },
    /**
     * searchgpcpWithParams
     */
    async searchgpcpWithParams () {
      if (this.whereFilter.search_param.length == 0) {
        this.showLoadMoreBtn = true
      }
      this.currentBatchNo = 1
      this.gpcpList()
    },
    /**
     * loadMoreData
     */
    async loadMoreData () {
      this.currentBatchNo = this.currentBatchNo + 1
      this.gpcpList(true)
    },
    /**
     * Calling Function as per whereFilter
    */
    async getgpcpDateWise () {
      this.gpcpList()
      await this.setDateFilter()
    },
    /**
     * Setting Date Range in the LS
     */
    async setDateFilter () {
      let endDate = this.whereFilter.dateRange.endDate
      this.whereFilter.dateRange.endDate = new Date(new Date(endDate).setDate(new Date(endDate).getDate() + 1))
      let whereDateFilter = { dateRange: this.whereFilter.dateRange }
      await this.$store.commit("DateFilter/addSelectedDate", whereDateFilter)
    },
    /**
     * gpcpList
     */
    async gpcpList (loadViaLoadMore = false) {
      try {
        // setting data for pagination
        this.whereFilter.currentBatchNo = this.currentBatchNo
        this.whereFilter.dataPerPage = this.dataPerPage
        this.whereFilter.search_param = this.search_param

        let gpcpListResp = await gpathCompanys.gpcpList(this, this.whereFilter)
        if (!gpcpListResp.resp_status) {
          if (this.currentBatchNo > 1) {
            // anything less than 1 (which is the first page) becomes an invalid prop for the b-pagination component
            this.currentBatchNo--
          }
          this.showLoadMoreBtn = false
          return
        }
        if (gpcpListResp.resp_status) {
          if (this.whereFilter.search_param.length >= 0 && !loadViaLoadMore) {
            this.gpcpObjList = [ ...gpcpListResp.resp_data.data ]
          }
          else {
            this.gpcpObjList = [ ...this.gpcpObjList, ...gpcpListResp.resp_data.data ]
          }
          this.showLoadMoreBtn = true

          // Adding the serial numbers:
          this.gpcpObjList.forEach((s, index) => { s.id = index + 1 })
          this.totalRows = this.gpcpObjList.length
        }
        else {
          this.showLoadMoreBtn = false
          this.currentBatchNo = this.currentBatchNo - 1
          this.toastMsg = gpcpListResp.resp_msg
          this.toastVariant = "danger"
          this.showToast = true
        }
      }
      catch (err) {
        console.error("Exception occurred at gpcpList() and Exception:", err)
      }
    },
    /**
     * gpcpAdd
     */
    gpcpAdd (type) {
      try {
        if (type === "FULLPAGE") {
          this.$router.push("/admin/gpcp_add")
        }
        else {
          this.showModelgpathCompanyAdd = true
        }
      }
      catch (err) {
        console.error("Exception occurred at gpcpAdd() and Exception:", err.message)
      }
    },
    /**
     * gpcpEdit
     */
    gpcpEdit (type, item) {
      try {
        if (type === "FULLPAGE") {
          this.$router.push("/admin/gpcp_edit/" + this.gpcpEditObj.gpcp_id)
        }
        else {
          this.gpcpEditObj = item
          this.showModelgpathCompanyEdit = true
        }
      }
      catch (err) {
        console.error("Exception occurred at gpcpEdit() and Exception:", err.message)
      }
    },
    /**
     * showgpath_companyDeleteDialog
     */
    showgpath_companyDeleteDialog (item) {
      try {
        this.delObj = item
        this.showModelgpath_companyDelete = true
      }
      catch (err) {
        console.error("Exception occurred at showgpath_companyDeleteDialog() and Exception:", err.message)
      }
    },
    /**
     * gpcpDelete
     */
    async gpcpDelete () {
      try {
        let gpcpDelResp = await gpathCompanys.gpcpDelete(this, this.delObj.gpcp_id)
        await ApiResponse.responseMessageDisplay(this, gpcpDelResp)

        if (gpcpDelResp && !gpcpDelResp) {
          this.showModelgpath_companyDelete = false
          return false
        }

        let index = this.gpcpObjList.indexOf(this.delObj)
        this.gpcpObjList.splice(index, 1)
        this.totalRows = this.totalRows - 1
        this.showModelgpath_companyDelete = false
      }
      catch (err) {
        console.error("Exception occurred at gpcpDelete() and Exception:", err.message)
      }
    },
    /**
     * closegpathCompanyAddModal
     */
    closegpathCompanyAddModal (gpcpAddData) {
      try {
        if (gpcpAddData) {
          if (this.gpcpObjList && this.gpcpObjList.length >= 1) {
            let gpcpObjLength = this.gpcpObjList.length
            let lastId = this.gpcpObjList[gpcpObjLength - 1]["id"]
            gpcpAddData.id = lastId + 1
          }
          else {
            this.gpcpObjList = []
            gpcpAddData.id = 11111
          }

          gpcpAddData.created_on = moment()
          this.gpcpObjList.unshift(gpcpAddData)
          this.totalRows = this.totalRows + 1
        }

        this.showModelgpathCompanyAdd = false
      }
      catch (err) {
        console.error("Exception occurred at closegpcpAddModal() and Exception:", err.message)
      }
    },
    /**
     * closegpathCompanyEditModal
     */
    closegpathCompanyEditModal () {
      try {
        this.showModelgpathCompanyEdit = false
      }
      catch (err) {
        console.error("Exception occurred at closegpathCompanyEditModal() and Exception:", err.message)
      }
    },
    /**
     * gpaths product Id List Get
    */
    async gpathsproductIdListGet () {
      try {
        const gpaList = await GPathConfig.gpcList(this, this.whereFilter)
        if (!gpaList.resp_status) {
          ApiResponse.responseMessageDisplay(this, gpaList)
          return
        }
        this.assessmentObjList = gpaList.resp_data.data
        this.gpcPdtIdList = this.assessmentObjList.map(gpc => ({
          id: gpc.gpc_pdt_id
        }))
      }
      catch (err) {
        console.error("Exception in gpathsproductIdListGet() and err: ", err.message)
      }
    }
  }
}
</script>
